import { supabase } from '../lib/supabase';

export async function getUserContentAnalytics(userId: string) {
  const { data: pins, error: pinsError } = await supabase
    .from('audio_pins')
    .select('*')
    .eq('user_id', userId);

  if (pinsError) throw pinsError;

  return pins || [];
}

export function calculateAnalyticsSummary(pins: any[]) {
  const totalPlays = pins.reduce((sum, pin) => sum + (pin.play_count || 0), 0);
  const totalLikes = pins.reduce((sum, pin) => sum + (pin.like_count || 0), 0);
  const totalPins = pins.length;

  return {
    totalPlays,
    totalLikes,
    totalPins,
    avgPlaysPerPin: totalPins > 0 ? Math.round(totalPlays / totalPins) : 0,
    avgLikesPerPin: totalPins > 0 ? Math.round(totalLikes / totalPins) : 0,
  };
}
